import { Component } from '@angular/core';
import { ContentTooltip } from 'src/app/models/content-tooltip';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.' + environment.brand + '.html',
    styleUrls: ['./not-found.component.' + environment.brand + '.css']
})
export class NotFoundComponent {
    contentTooltips: ContentTooltip[] = [];

    constructor() {
        //console.log('NotFoundComponent.constructor');        
    }
}
